module.exports = __webpack_public_path__ + "media/jojo_ayayay.d2f854b1.mp3";